import { PatientFilters } from "../store/Patients/types";
import { apiV2, wrapResponse } from "./repository";
import { CreateUserByAdminDto, FindPatientsForEventDto, UpdateUserByAdminDto } from "../sdk";

export const PatientRepository = {
  async find(filters: PatientFilters, page: number) {
    // TODO remove mapping
    return wrapResponse(apiV2.userAdmin.findPatientsByAdmin({
      page,
      filter: {
        ...filters,
        // @ts-ignore
        ageMin: filters.ageMin ? +filters.ageMin : undefined,
        // @ts-ignore
        ageMax: filters.ageMax ? +filters.ageMax : undefined,
        // @ts-ignore
        gender: filters.gender == 'all' ? undefined : filters.gender,
        // @ts-ignore
        language: filters.language == 'all' ? undefined : filters.language
      }
    }))
  },

  getArchived() {
    return wrapResponse(apiV2.userAdmin.getArchivedPatients())
  },

  async getById(id: string) {
    return wrapResponse(apiV2.userAdmin.getSimplePatientProfile(id))
  },

  async findForEvent(query: FindPatientsForEventDto) {
    return wrapResponse(apiV2.userAdmin.findPatientsForEvent(query))
  },

  async update(id: string, changedFields: UpdateUserByAdminDto) {
    const birthDate = changedFields.birthDate && new Date(changedFields.birthDate).toISOString()

    return wrapResponse(apiV2.userAdmin.updatePatient(id, {
      ...changedFields,
      birthDate
    }))
  },

  async create(fields: CreateUserByAdminDto) {
    return wrapResponse(apiV2.userAdmin.createPatient(fields))
  },

  async archive(id: string) {
    return wrapResponse(apiV2.userAdmin.archivePatient(id))
  },

  async delete(id: string) {
    return wrapResponse(apiV2.userAdmin.deleteArchivedPatient(id))
  },

  async restore(id: string) {
    return wrapResponse(apiV2.userAdmin.restoreAchievedPatient(id))
  },
}
